import React, { Component } from "react";

import FontIcon from "material-ui/FontIcon";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import Store from "../SessionStorage";
import { sessionStorageAction } from "../utils/index";
import WaitingDocuments from "./WaitingDocuments";

export class UploadPj extends Component {
  state = {
    isLoading: false,
    accessToken: "",
    numClient: "",
    numContract: "",
    file: [],
    dropzone: null,
    links: [],
    personId: "",
    codeProduit: ""
  };

  componentDidMount = () => {
    const numClient = Store.get(
      sessionStorageAction.dashboard.client.numClient
    );
    const numContract = Store.get(
      sessionStorageAction.dashboard.client.numContract
    );
    const personId = Store.get(sessionStorageAction.dashboard.client.numAltima)
    const codeProduit = Store.get(sessionStorageAction.dashboard.client.codeProduit)

    this.setState({
      accessToken: Store.get(sessionStorageAction.dashboard.accessToken),
      numClient,
      personId,
      codeProduit,
      numContract,
    });
  };

  logout = () => {
    window.sessionStorage.removeItem(
      sessionStorageAction.dashboard.accessToken
    );
    window.location.href = "/particuliers/auto/assurance-auto-usage/espace-client";
  };

  render() {
    return (
      <div>
        <div className="container" style={{ width: "80%" }}>
          <div className="row">
            <div className="col-sm-12">
              <a
                className="admin-dashboard-deconnection"
                onClick={this.logout}
                title="Déconnexion"
              >
                <span>Déconnexion</span>
                <i className="material-icons">power_settings_new</i>
              </a>
              <a
                id="btnHomeDashboard"
                className="admin-dashboard-deconnection"
                href={`/particuliers/auto/assurance-auto-usage/espace-client?token=${Store.get(
                  sessionStorageAction.dashboard.accessToken
                )}`}
                title="Espace perso"
              >
                <i className="material-icons">home</i>
              </a>
            </div>
          </div>
        </div>
        <div className="main-page-header">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <h1>Vos pièces justificatives</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="admin-dashboard">
          {this.state.numContract &&
          <WaitingDocuments
            retrieveDocuments={this.state.pieces}
            codeProduit={this.state.codeProduit}
            policyId={this.state.numContract}
            personId={this.state.personId}
          />}
          <MuiThemeProvider>
            <div
              style={{
                marginTop: 35,
                marginLeft: 20,
                color: "#FFF",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FontIcon
                  style={{ width: 18, marginRight: 5 }}
                  className="material-icons"
                  color="rgb(255, 186, 0)"
                >
                  information
                </FontIcon>
                <h4 style={{ fontSize: 14 }}>
                  <strong>&nbsp;INFORMATIONS</strong>
                </h4>
              </div>
              <div>
                <ul style={{ color: "black", margin: 0 }}>
                  <li>
                    <strong style={{ fontSize: 14, fontStyle: "italic" }}>10MB maximum par fichier</strong>
                  </li>
                </ul>
              </div>
            </div>
          </MuiThemeProvider>
        </div>
      </div>
    );
  }
}
